import { Suspense } from "react";
import SuspenseLoader from "../../../componets/SuspenseLoader";

export const Loader = (Component: any) => {
  const WrappedComponent = (props: any) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

  WrappedComponent.displayName = `Loader(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};
